import store from '@/store';

export const isAuthenticatedGuard = async (to, from, next) => {
   const response = await store.dispatch('auth/checkAuthentication');

   if (response?.ok) {
      next(); // Permitir acceso si está autenticado
   } else {
      next({ name: 'login' }); // Redirigir al login si no está autenticado
   }
};

export const isBsaUser = async (to, from, next) => {
   const response = await store.dispatch('auth/isBsaUser');
   if (response?.ok) {
      next(); // Permitir acceso si es usuario BSA
   } else {
      next({ name: 'menu' });
   }
};

export const isReportesUser = async (to, from, next) => {
   const response = await store.dispatch('auth/isReportesUser');
   if (response?.ok) {
      next(); // Permitir acceso si es usuario con acceso a reportes
   } else {
      next({ name: 'menu' });
   }
};

export const isAutomotorUser = async (to, from, next) => {
   const response = await store.dispatch('auth/isAutomotorUser');
   if (response?.ok) {
      next();
   } else {
      next({ name: 'menu' });
   }
};
